"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.adjustDate = exports.nowUnixDateTimeCoded = exports.nowUnixDateTime = exports.timeConverter = void 0;
var timeConverter = function (unixTimestamp) {
    var a = new Date(unixTimestamp * 1000);
    return a.toLocaleDateString('en-gb', {
        year: 'numeric',
        month: 'long',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false,
    });
};
exports.timeConverter = timeConverter;
var nowUnixDateTime = function () {
    return Date.now() / 1000;
};
exports.nowUnixDateTime = nowUnixDateTime;
var nowUnixDateTimeCoded = function () {
    return Uint32Array.of((0, exports.nowUnixDateTime)());
};
exports.nowUnixDateTimeCoded = nowUnixDateTimeCoded;
var adjustDate = function (timestamp, device, fromPuffRecord) {
    try {
        var refDate = new Date();
        var currentTime_1 = Date.now();
        refDate.setFullYear(2018);
        if (timestamp < refDate.getTime()) {
            if (device) {
                if (fromPuffRecord) {
                    onDataReceived(device);
                }
                return device.getDateTimeInfo().then(function (timeInfo) {
                    if (timeInfo) {
                        var time = timeInfo.time, timeUnix = timeInfo.timeUnix;
                        if (!isNaN(timeUnix) && !isNaN(timestamp) && time.length > 0) {
                            var adjustedTimeStamp = currentTime_1 - timeUnix * 1000 + timestamp;
                            console.log(adjustedTimeStamp, 'adjustedTimeStamp TimeInfo');
                            return adjustedTimeStamp / 1000;
                        }
                        else {
                            throw new Error('Invalid time, discarding puff...');
                        }
                    }
                });
            }
        }
        else {
            return Promise.resolve(timestamp / 1000);
        }
    }
    catch (err) {
        console.log(err);
    }
};
exports.adjustDate = adjustDate;
function debounce(func, delay) {
    var timeoutId;
    return function () {
        var _this = this;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        clearTimeout(timeoutId);
        timeoutId = setTimeout(function () {
            func.apply(_this, args);
        }, delay);
    };
}
var onDataReceived = function (device) {
    debounceSetDeviceTime(device);
};
var setDeviceTime = function (device) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, device.setDateTimeConfig(Date.now() / 1000)];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}); };
var debounceSetDeviceTime = debounce(setDeviceTime, 3000);
